import React from "react";

const WardrobeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.3915 13.1032L1.6279 24.4132C1.35695 24.6522 1.1599 24.978 1.06448 25.3454C0.969057 25.7129 0.97979 26.1037 1.09505 26.4643C1.21032 26.8248 1.42445 27.1369 1.70794 27.3577C1.99143 27.5784 2.33013 27.697 2.67741 27.6966L26.1515 26.9772C27.7446 26.9772 28.4536 25.4975 27.2104 24.4132L14.3915 13.1032Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M14.959 12.5419L1.6279 24.4132C1.35695 24.6522 1.1599 24.978 1.06448 25.3454C0.969057 25.7129 0.97979 26.1037 1.09505 26.4643C1.21032 26.8248 1.42445 27.1369 1.70794 27.3577C1.99143 27.5784 2.33013 27.697 2.67741 27.6966H27.3073C28.9005 27.6966 29.7432 25.5844 28.5 24.5L14.959 12.5419Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M10.6641 6.28015C10.666 5.67701 10.8571 5.08577 11.217 4.57141C11.5769 4.05704 12.0916 3.63934 12.7046 3.36369C13.3176 3.08804 14.0055 2.96512 14.6929 3.00853C15.3803 3.05194 16.0408 3.25989 16.6022 3.60972C17.1636 3.95954 17.6042 4.43787 17.876 4.99213C18.1477 5.5464 18.24 6.15522 18.1429 6.75235C18.0459 7.34948 17.7631 7.91187 17.3255 8.3778C16.8878 8.84373 16.3123 9.19525 15.6617 9.39416C15.2811 9.4542 14.9416 9.64077 14.7144 9.91463C14.4872 10.1885 14.3895 10.5286 14.4421 10.8639V13.1032"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M10.6641 6.28015C10.666 5.67701 10.8571 5.08577 11.217 4.57141C11.5769 4.05704 12.0916 3.63934 12.7046 3.36369C13.3176 3.08804 14.0055 2.96512 14.6929 3.00853C15.3803 3.05194 16 3 17 3.5C18 4 18.4592 4.67294 18.731 5.22721C19.0027 5.78147 19.095 6.39029 18.9979 6.98742C18.9008 7.58455 18.6181 8.14694 18.1804 8.61287C17.7428 9.0788 17.3861 9.19525 16.7355 9.39416C16.3549 9.4542 16.0154 9.64077 15.7882 9.91463C15.5609 10.1885 15.4633 10.5286 15.5158 10.8639V13.1032"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
  </svg>
);

export default WardrobeIcon;
